export default __webpack_public_path__ + "static/media/a012-market-10.2784aece.svg";